export default function() {
    return {
        username: '',
        password: '',
        loginErrorMessage: ''
    }
}
